import React from 'react';

const PlaceHolder = () => (
    <div style={{ height: '50px' }} />
);

export default PlaceHolder;